import React from 'react';
import PropTypes from 'prop-types';
import HardToken from './HardToken';
import { shouldShowActivateHardTokenSVG } from './HomepageTilesUtils';

function ActivateHardTokenTile(props) {
  return (
    <div onClick={props.onClick} className="l-tile c-hard-token-tile">
      <div className="">
        <h3 className="c-hard-token-tile__heading">
          {props.content.activateHardTokenHeading}
        </h3>
        <div className="c-hard-token-tile__body">
          <div className="c-hard-token-tile__left">
            <p>{props.content.activateHardTokenDescription}</p>
            <a className="c-btn c-btn--default" href="javascript:void(0)">
              {props.content.activateHardTokenLink}
            </a>
          </div>
          {shouldShowActivateHardTokenSVG() && (
            <div className="c-hard-token-tile__right">
              <HardToken />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

ActivateHardTokenTile.propTypes = {
  content: PropTypes.object,
  onClick: PropTypes.func,
};

export default ActivateHardTokenTile;
